const formatPhoneNumber = (phoneNumber: string): string => {
  if (!phoneNumber) return "";
  return phoneNumber.length === 11 && phoneNumber.startsWith("1")
    ? phoneNumber.slice(1)
    : phoneNumber
        .replaceAll("+1", "")
        .replaceAll("+", "")
        .replaceAll("(", "")
        .replaceAll(")", "")
        .replaceAll("-", "")
        .replaceAll("_", "")
        .replaceAll(" ", "");
};

export default formatPhoneNumber;
